module.exports = __webpack_public_path__ + "img/star.c14c9cce.svg";